const advanceValidateForm = (formData, propertyType, serviceType, propertySubType,selfType) => {
  const newErrors = {};

  if (selfType === 6 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'apartment') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (parseFloat(formData.propertyDetails.carpet_area) > parseFloat(formData.propertyDetails.buildup_area)) {
      newErrors.carpet_area = "Carpet Area must be less than Built-Up Area.";
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'independent_floor') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'independent_house') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'villa') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'apartment') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'independent_floor') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'independent_house') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'rent' && propertySubType === 'villa') {
    if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    // if (!formData.propertyDetails.open_parking) newErrors.open_parking = "Select open parking is required.";
    // if (!formData.propertyDetails.closed_parking) newErrors.closed_parking = "Select closed parking is required.";
    // if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (['seprate'].includes(formData.propertyDetails.parking_charge)) {
      if (!formData.propertyDetails.parking_charge_amount.trim()) {
        newErrors.parking_charge_amount = "Parking Charge Amount is required.";
      }
    }
    if (['custom'].includes(formData.propertyDetails.painting_charge)) {
      if (!formData.propertyDetails.painting_charge_amount.trim()) {
        newErrors.painting_charge_amount = "Painting Charge Amount is required.";
      }
    }
  }
  if ( propertyType === 'residential' && serviceType === 'living') {
    if (!formData.propertyDetails.non_veg) newErrors.non_veg = "Select Non Veg Allowed is required.";
    if (!formData.propertyDetails.opposite_sex) newErrors.opposite_sex = "Select Opposite Sex Allowed is required.";
    if (!formData.propertyDetails.drinking_allowed) newErrors.drinking_allowed = "Select Drinking Allowed is required.";
    if (!formData.propertyDetails.smoking_allowed) newErrors.smoking_allowed = "Select Smoking Allowed is required.";
    if (!formData.propertyDetails.visitor_allowed) newErrors.visitor_allowed = "Select Visitor Allowed is required.";
    if (!formData.propertyDetails.guardian_allowed) newErrors.guardian_allowed = "Select Guardian Allowed is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property Description is required.";
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'apartment') {
  //   if (!formData.propertyDetails.floor_no) {
  //     newErrors.floor_no = "Floor No. is required.";
  // }
  if (!formData.propertyDetails.total_floor) {
      newErrors.total_floor = "Select total floor is required.";
  }
  if (formData.propertyDetails.floor_no && formData.propertyDetails.total_floor && Number(formData.propertyDetails.floor_no) > Number(formData.propertyDetails.total_floor)) {
      newErrors.floor_no = "Floor No. cannot be greater than Total Floor.";
  }
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
     //if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    //if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'independent_floor') {
  //   if (!formData.propertyDetails.floor_no) {
  //     newErrors.floor_no = "Floor No. is required.";
  // }
  if (!formData.propertyDetails.total_floor) {
      newErrors.total_floor = "Select total floor is required.";
  }
  if (
      formData.propertyDetails.floor_no &&
      formData.propertyDetails.total_floor &&
      Number(formData.propertyDetails.floor_no) > Number(formData.propertyDetails.total_floor)
  ) {
      newErrors.floor_no = "Floor No. cannot be greater than Total Floor.";
  }
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    //if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'independent_house') {
  //   if (!formData.propertyDetails.floor_no) {
  //     newErrors.floor_no = "Floor No. is required.";
  // }
  if (!formData.propertyDetails.total_floor) {
      newErrors.total_floor = "Select total floor is required.";
  }
  if (
      formData.propertyDetails.floor_no &&
      formData.propertyDetails.total_floor &&
      Number(formData.propertyDetails.floor_no) > Number(formData.propertyDetails.total_floor)
  ) {
      newErrors.floor_no = "Floor No. cannot be greater than Total Floor.";
  }
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    // if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'villa') {
  //   if (!formData.propertyDetails.floor_no) {
  //     newErrors.floor_no = "Floor No. is required.";
  // }
  if (!formData.propertyDetails.total_floor) {
      newErrors.total_floor = "Select total floor is required.";
  }
  if (
      formData.propertyDetails.floor_no &&
      formData.propertyDetails.total_floor &&
      Number(formData.propertyDetails.floor_no) > Number(formData.propertyDetails.total_floor)
  ) {
      newErrors.floor_no = "Floor No. cannot be greater than Total Floor.";
  }
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    // if (!formData.propertyDetails.balcony) newErrors.balcony = "Select Balcony is required.";
    // if (!formData.propertyDetails.bathroom) newErrors.bathroom = "Select Bathroom is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'plot') {
    // if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.width_facing_road) newErrors.width_facing_road = "Width of facing road is required.";
    if (!formData.propertyDetails.corner_plot) newErrors.corner_plot = "Corner Plot is required.";
    if (!formData.propertyDetails.boundary_wall) newErrors.boundary_wall = "Boundary Wall is required.";
    // if (!formData.propertyDetails.plot_approved) newErrors.plot_approved = "Plot approved by authority is required.";
    if (['1'].includes(formData.propertyDetails.plot_approved)) {
      if (!formData.propertyDetails.plot_authority.trim()) {
        newErrors.plot_authority = " Approving Authorities is required.";
      }
    }
    // if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 6 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'agricultural_land') {
    // if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.width_facing_road) newErrors.width_facing_road = "Width of facing road is required.";
    if (!formData.propertyDetails.corner_plot) newErrors.corner_plot = "Corner Plot is required.";
    if (!formData.propertyDetails.boundary_wall) newErrors.boundary_wall = "Boundary Wall is required.";
    // if (!formData.propertyDetails.plot_approved) newErrors.plot_approved = "Plot approved by authority is required.";
    if (['1'].includes(formData.propertyDetails.plot_approved)) {
      if (!formData.propertyDetails.plot_authority.trim()) {
        newErrors.plot_authority = " Approving Authorities is required.";
      }
    }
    // if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'apartment') {
    //if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  } 
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'independent_floor') {
    //if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'independent_house') {
    //if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'villa') {
    //if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'plot') {
    //if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    // if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.width_facing_road) newErrors.width_facing_road = "Width of facing road is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (!formData.propertyDetails.corner_plot) newErrors.corner_plot = "Corner Plot is required.";
    if (!formData.propertyDetails.boundary_wall) newErrors.boundary_wall = "Boundary Wall is required.";
    
  }
  if (selfType === 5 && propertyType === 'residential' && serviceType === 'sell' && propertySubType === 'agricultural_land') {
    //if (!formData.propertyDetails.property_age) newErrors.property_age = "Select Property age is required.";
    // if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    // if (!formData.propertyDetails.facing) newErrors.facing = "Select Facing is required.";
    if (!formData.propertyDetails.width_facing_road) newErrors.width_facing_road = "Width of facing road is required.";
    if (!formData.propertyDetails.address) newErrors.address = "Enter Address is required.";
    if (!formData.propertyDetails.corner_plot) newErrors.corner_plot = "Corner Plot is required.";
    if (!formData.propertyDetails.boundary_wall) newErrors.boundary_wall = "Boundary Wall is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'office') {
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
    // if (!formData.propertyDetails.service_lift) newErrors.service_lift = "Enter Service Lift is required.";
    // if (!formData.propertyDetails.private_washroom) newErrors.private_washroom = "Enter Private Washroom is required.";
    // if (!formData.propertyDetails.public_washroom) newErrors.public_washroom = "Enter Public Washroom is required.";
    // if (!formData.propertyDetails.public_lift) newErrors.public_lift = "Enter Public Lift is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'retailshop') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    // if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    // if (!formData.propertyDetails.your_floor) newErrors.your_floor = "Select your floor is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
    // if (!formData.propertyDetails.private_washroom) newErrors.private_washroom = "Enter Private Washroom is required.";
    // if (!formData.propertyDetails.public_washroom) newErrors.public_washroom = "Enter Public Washroom is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'showroom') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    // if (!formData.propertyDetails.total_floor) newErrors.total_floor = "Select total floor is required.";
    // if (!formData.propertyDetails.your_floor) newErrors.your_floor = "Select your floor is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
    // if (!formData.propertyDetails.private_washroom) newErrors.private_washroom = "Enter Private Washroom is required.";
    // if (!formData.propertyDetails.public_washroom) newErrors.public_washroom = "Enter Public Washroom is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'warehouse') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'plot') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'other') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'office') {
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
    // if (!formData.propertyDetails.service_lift) newErrors.service_lift = "Enter Service Lift is required.";
    // if (!formData.propertyDetails.private_washroom) newErrors.private_washroom = "Enter Private Washroom is required.";
    // if (!formData.propertyDetails.public_washroom) newErrors.public_washroom = "Enter Public Washroom is required.";
    // if (!formData.propertyDetails.public_lift) newErrors.public_lift = "Enter Public Lift is required.";
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'retailshop') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'showroom') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'warehouse') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'plot') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'rent' && propertySubType === 'other') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'office') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'retailshop') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'showroom') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'warehouse') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'plot') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 6 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'other') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'office') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'retailshop') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'showroom') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.entrance_width) newErrors.entrance_width = "Enter Entrace Width is required.";
    if (!formData.propertyDetails.ceiling_height) newErrors.ceiling_height = "Enter Ceiling Width is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'warehouse') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'plot') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  if (selfType === 5 && propertyType === 'commercial' && serviceType === 'sell' && propertySubType === 'other') {
    if (!formData.propertyDetails.property_description) newErrors.property_description = "Enter Property description is required.";
    if (!formData.propertyDetails.negotiable) newErrors.negotiable = "Select Negotiable is required.";
  }
  return newErrors;

}
export default advanceValidateForm;

export const propertyValuationDetailValidation = (formData) =>{
  const newErrors = {};
  if (["office","showroom","retailshop","warehouse"].includes(formData.propertyDetails.property_type)) {
    if (!formData.propertyDetails.parking_open) newErrors.parking_open = "Parking Open is required.";
    if (!formData.propertyDetails.parking_covered) newErrors.parking_covered = "Parking Closed is required.";
  }
  if (["apartment","villa","independent_floor","independent_house","plot","agricultural_land"].includes(formData.propertyDetails.property_type)) {
    if (!formData.propertyDetails.facing) newErrors.facing = "Facing is required.";
    if (!formData.propertyDetails.over_looking) newErrors.over_looking = "Over Looking is required.";
  }
  return newErrors;
}